import { render, staticRenderFns } from "./BasicSetupScreen.vue?vue&type=template&id=bb2199be&"
import script from "./BasicSetupScreen.vue?vue&type=script&lang=ts&"
export * from "./BasicSetupScreen.vue?vue&type=script&lang=ts&"
import style0 from "./BasicSetupScreen.vue?vue&type=style&index=0&id=bb2199be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports